var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c(_vm.getComponentName(_vm.item),_vm._b({tag:"component"},'component',_vm.getInnerComponentProps(_vm.item),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }